import React from "react";

function CostReportTable(props) {
  const { data, totalValues, seg } = props;

  const roundToTwo=(num)=> {
  return  Number(num.toFixed(2));
}

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tax-table">
        <table className="table last-column" style={seg === "fo" ? { width: "210%" } : {}}>
          <thead>
            <>
              <tr className="">
                <th scope="col">Txn.Date</th>
                <th scope="col">Scrip</th>
                <th scope="col">Brokerage</th>
                {seg === "fo" && (
                  <>
                    <th scope="col">Fut Brokerage</th>
                    <th scope="col">Opt Brokerage</th>
                  </>
                )}
                <th scope="col">GST (₹)</th>
                <th scope="col">Sec.Txn.Tax </th>
                <th scope="col">Stamp Duty</th>
                <th scope="col">IPFT CHRG</th>
                <th scope="col">Sebi Fees</th>
                <th scope="col">Txn Charges</th>
                {seg === "fo" && (
                  <>
                    <th scope="col">Fut Turn Tax</th>
                    <th scope="col">Opt Turn Tax</th>
                  </>
                )}
                <th scope="col">Other Charges</th>
                <th scope="col">Total Charges</th>
              </tr>
            </>
          </thead>
          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    <tr key={key} className="">
                      <td>{item?.txnDate || "-"}</td>
                      <td>{item?.scrip || "-"}</td>
                      <td>{item?.brokerage || 0}</td>
                      {seg === "fo" && (
                        <>
                          <td>{item?.futBrokerage || 0}</td>
                          <td>{item?.optBrokerage || 0}</td>
                        </>
                      )}
                      <td>{item?.gst || 0}</td>
                      <td>{item?.secTxnTax || 0}</td>
                      <td>{item?.stampDuty || 0}</td>
                      <td>{item?.ipftChrg || 0}</td>
                      <td>{item?.sebiFees || 0}</td>
                      <td>{item?.txnCharges || 0}</td>
                      {seg === "fo" && (
                        <>
                          <td>{item?.futTurnTax || 0}</td>
                          <td>{item?.optTurnTax || 0}</td>
                        </>
                      )}
                      <td>{item?.otherCharges || 0}</td>
                      <td>{item?.totalCharges || 0}</td>
                    </tr>
                  </>
                );
              })}
          </tbody>

          <tbody className="tax-total-values">
            <tr>
              <td>Total</td>
              <td></td>
              <td>{roundToTwo(totalValues.totalBrokerage)}</td>
              {seg === "fo" && (
                <>
                  <td></td>
                  <td></td>
                </>
              )}
              <td>{roundToTwo(totalValues.totalGst)}</td>
              <td>{roundToTwo(totalValues.totalSecTxnTax)}</td>
              <td>{roundToTwo(totalValues.totalStampDuty)}</td>
              <td>{roundToTwo(totalValues.totalIpftCharge)}</td>
              <td>{roundToTwo(totalValues.totalSebiFees)}</td>
              <td>{roundToTwo(totalValues.totalTxnChrg)}</td>
              {seg === "fo" && (
                <>
                  <td></td>
                  <td></td>
                </>
              )}
              <td>{roundToTwo(totalValues.totalOthrChrg)}</td>
              <td>{roundToTwo(totalValues.totalChrg)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default CostReportTable;
